import merchantAccountFields from '../../fields/merchantAccountFields';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import CONTRACT_ACCESS from '../apiUrls';
import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';

/**
 * @param responseData response.data object
 * @param responseData.uuid string
 * @param responseData.email string
 * @param responseData.label string
 * @param responseData.provider string
 * @param responseData.status string
 * @param responseData.createdAt string
 * @param responseData.updatedAt string
 * @param response
 * @param responseData.items
 * @param responseData.totalResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};
    const mappedItems = items.map(item => ({
        [merchantAccountFields.UUID.key]: item[merchantAccountFields.UUID.key],
        [merchantAccountFields.EMAIL.key]: item[merchantAccountFields.EMAIL.key],
        [merchantAccountFields.LABEL.key]: item[merchantAccountFields.LABEL.key],
        [merchantAccountFields.ORGANIZATION_UUID.key]: item[merchantAccountFields.ORGANIZATION_UUID.key],
        [merchantAccountFields.STATUS.key]: item[merchantAccountFields.STATUS.key],
        [merchantAccountFields.CREATED_AT.key]: item[merchantAccountFields.CREATED_AT.key],
        [merchantAccountFields.UPDATED_AT.key]: item[merchantAccountFields.UPDATED_AT.key]
    }));

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetMerchantAccounts = ({ query, organizationId }, enabled) => {
    return {
        queryKey: [CONTRACT_ACCESS.COLLECTION.queryKey, query, organizationId],
        queryFn: async () => {
            const response = await client.get(buildUrl(replaceParameters(CONTRACT_ACCESS.COLLECTION.url, { organizationId: organizationId }), query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetMerchantAccounts;